import { action, makeObservable, observable } from "mobx";
import ProgressIndicatorModel, {
  ProgressIndicatorModel as IProgressIndicatorModel
} from "../../../../../../../../components/widgets/ProgressIndicator/ProgressIndicator_model";
import TrainingCoursesApi, {
  TrainingCoursesApi as ITrainingCoursesApi
} from "../../../../../../../../services/api/v2/trainingCourses/TrainingCourses.api";
import ModalContext from "../../../../../../../modalZ/context/ModalContext";

export class TrainingCourseProjectStakeholderOwnerLinkModalModel {
  @observable selectedProjectStakeholderOwnerIds: number[] = [];
  @observable isLoading: boolean = true;
  organisationId: number;
  projectId: number;
  trainingCoursesProvider: ITrainingCoursesApi;
  trainingCourse: FP.Entities.ITrainingCourse;
  httpProgress: IProgressIndicatorModel;

  /**
   *
   */
  constructor(organisationId: number, projectId: number, trainingCourse: FP.Entities.ITrainingCourse) {
    makeObservable(this);
    this.organisationId = organisationId;
    this.projectId = projectId;
    this.trainingCoursesProvider = TrainingCoursesApi;
    this.httpProgress = ProgressIndicatorModel;
    this.trainingCourse = trainingCourse;
  }

  onMount = async () => {
    await this.getSelectedProjectStakeholderOwners();
    this.setIsLoading(false);
  };

  @action
  setSelectedProjectStakeholderOwners = (selectedProjectStakeholderOwnerIds: number[]) => {
    this.selectedProjectStakeholderOwnerIds = selectedProjectStakeholderOwnerIds;
  };

  @action
  setIsLoading = (isLoading: boolean) => {
    this.isLoading = isLoading;
  };

  getSelectedProjectStakeholderOwners = async () => {
    const res = await this.trainingCoursesProvider.getTrainingCourseProjectStakeholdersByTrainingCourseId(
      this.organisationId,
      this.projectId,
      this.trainingCourse.id
    );

    if (!res || res.isError) return;

    this.setSelectedProjectStakeholderOwners(res.payload);
  };

  assignProjectStakeholderOwnersToTrainingCourses = async (actionIds, onAssignSuccess?: any) => {
    await this.trainingCoursesProvider
      .addBulkProjectStakeholdersToTrainingCourses(
        this.organisationId,
        this.projectId,
        [this.trainingCourse.id],
        actionIds
      )
      .then(async e => await onAssignSuccess());

    ModalContext.hide();
  };
}
